module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": '' + _vm.filteredClients.length + ' kunder'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewClient()
      }
    }
  }, [_vm._v("Ny kunde")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m30"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m40"
  }), _vm._v(" "), _c('div', {
    staticClass: "col m30"
  })]), _vm._v(" "), (_vm.filteredClients.length) ? _c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-c"
  }, [_vm._v("Aktive opgaver")]), _vm._v(" "), _c('th', {
    staticClass: "align-c"
  }, [_vm._v("Afsluttede opgaver")]), _vm._v(" "), (false && _vm.is_admin) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Samlet indtjening")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredClients), function(client, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": client
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + client['.key']
      }
    }, [_vm._v(_vm._s(client.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-c"
    }, [_vm._v("\n          " + _vm._s(client.active_projects_count) + "            \n        ")]), _vm._v(" "), _c('td', {
      staticClass: "align-c"
    }, [_vm._v("\n          " + _vm._s(client.finished_projects_count) + "\n        ")]), _vm._v(" "), (false && _vm.is_admin) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n          " + _vm._s(_vm.clientTotalEarning(client['.key'])) + "\n        ")]) : _vm._e()])
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClient()
      }
    }
  }, [_vm._v("Opret ny kunde")]), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "Dev data"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.filteredClients))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa9eab4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Clients.vue
// module id = 609
// module chunks = 1